export default {
  upcomingReservations: [],
  reservationList: [],
  meetingRoomReservations: {},
  meetingRoomData: {},
  reservationData: {},
  editBookData: {},
  reservationCredit: {
    remainingCredit: undefined
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/reservation/state.js